import { buildMakeUseAxios } from "@api";
import type { IPermission } from "@bbj-types/permission";
import { useCallback } from "react";

const settingsAxios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}`);

interface IGetPermissionsFilters {
  byTheme?: boolean;
}

export interface IPermissionByTheme {
  value: string;
  label: string;
  permissions: Pick<IPermission, "value" | "label" | "date">[];
}

export const isPermissionByTheme = (permission: IPermission | IPermissionByTheme): permission is IPermissionByTheme => {
  return Array.isArray((permission as IPermissionByTheme).permissions);
};

export const useGetPermissions = () => {
  const [state, execute, cancel] = settingsAxios<IPermission[] | IPermissionByTheme[], void, unknown>(
    {
      url: "/permissions",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    ({ byTheme }: IGetPermissionsFilters) => {
      return execute({
        params: {
          byTheme,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
